export default __webpack_public_path__ + "static/media/Shaka_particle_final_00.99e8cbb7.png";